export default {
  entities: {},
  settings: {
    delivery_settings: {
      delivery_time: 0,
      limit_cost: 0,
    },
    packing_cost: 0,
  },
  lunch: {
    items: [],
    loading: true,
  },
  venue: {
    name: "",
    menuById: [],
    menuRating: [],
    menu: [],
    positions: [],
    reviews: [],
    garcons: [],
    admin: {},
    supportAgents: [],
    schedule: {},
    mailings: [],
    paymentSettings: {},
    venueTags: [],
    gallery: [],
    commission: {},
  },
  guests: {
    list: [],
    listById: {},
    genders: [],
    age: [],
  },
  auth: false,
  gifts: { loading: true },
  chats: [],
  orders: [],
  fullMenu: { food: [], drink: [], loading: true },
  dashboard: {
    stats: {
      menu_views: null,
      orders_count: 0,
      revenue: 0,
      tips: 0,
      average_bill: 0,
      order_types: { takeaway: 0, delivery: 0 },
      garcons_tips: [],
      weekly_guests: [],
      weekly_items: [],
    },
    events: [],
  },
  corpMenu: { result: [], entities: {}, loading: true },
  tags: [],
  tagCategories: [],
  starsItems: [],
  starsPromocode: "",
  starsPromocodeAmount: "0",
  feedbacks: {
    venueFeedbacks: [],
  },
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js